import { useDispatch, useSelector } from "react-redux";
import { setCategoryNull, setNewFilters } from "../../redux/filtersSlice";
import { useTranslation } from 'react-i18next';

const ActivityTypeSelect = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { filtersObject } = useSelector(state => state.filters);

    // Gestisco il cambio di filtersObject al click
    const handleClick = (type) => {
        dispatch(setNewFilters({ activityType: [type] }));
        dispatch(setCategoryNull());
    }

    return (
        <div className="py-2 flex justify-center gap-2 w-full whitespace-nowrap flex-wrap bg-neutral-100 text-[12px] sm:text-[16px]"> {/* Rimuovere opacity-50 */}
            <div className={`py-1 px-2 cursor-pointer rounded-xl ${filtersObject.activityType && filtersObject.activityType.includes('Acqua') ? 'bg-[#37abc8]' : 'bg-[#37abc8]/10'}`} onClick={() => handleClick('Acqua')}>{t('poolBar.ActivityTypeSelect.water')}</div>
            <div className={`py-1 px-2 cursor-pointer rounded-xl ${filtersObject.activityType && filtersObject.activityType.includes('Aria') ? 'bg-[#d9d9d9]' : 'bg-[#d9d9d9]/50'}`} onClick={() => handleClick('Aria')}>{t('poolBar.ActivityTypeSelect.air')}</div>
            <div className={`py-1 px-2 cursor-pointer rounded-xl ${filtersObject.activityType && filtersObject.activityType.includes('Terra') ? 'bg-[#92c730]' : 'bg-[#92c730]/20'}`} onClick={() => handleClick('Terra')}>{t('poolBar.ActivityTypeSelect.land')}</div>
            <div className={`py-1 px-2 cursor-pointer rounded-xl ${filtersObject.activityType && filtersObject.activityType.includes('Neve') ? 'bg-[#b9dfff]' : 'bg-[#b9dfff]/30'}`} onClick={() => handleClick('Neve')}>{t('poolBar.ActivityTypeSelect.snow')}</div>
            <div className={`py-1 px-2 cursor-pointer rounded-xl ${filtersObject.activityType && filtersObject.activityType.includes('Best Views') ? 'bg-[#ffd815]' : 'bg-[#ffd815]/20'}`} onClick={() => handleClick('Best Views')}>{t('poolBar.ActivityTypeSelect.bestViews')}</div>
        </div>
    )
}

export default ActivityTypeSelect;